<template>
  <page>
    <page-poster-with-image
      :headline="headline"
      :paragraph="paragraph"
      src="/img/posters/promisesPoster.png"
      :alt="$t('woman.promises')"
    />
    <promises-items />
    <page-info-footer-row />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePosterWithImage from '@/components/common/PagePosterWithImage.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import PromisesItems from '@/components/promises/PromisesItems.vue';

import { PDF } from '@/constants';

export default {
  components: {
    Page,
    PagePosterWithImage,
    PageInfoFooterRow,
    PromisesItems,
  },
  data() {
    return {
      headline: this.$t('promises.poster.headline', {
        class: this.$style['promises-poster-highlighted-words']
      }),
      paragraph:
        this.$t('promises.poster.paragraph', {
          class: this.$style['promises-poster-highlighted-words'],
          privacyPolicy: PDF.PRIVACY_POLICY,
          term: PDF.TERM,
        }),
    };
  },
}
</script>

<style lang="scss" module>
@import '~@/assets/styles/colors';

.promises-poster {
  margin: 100px 0 70px 0;

  p {
    width: 591px;
    text-align: center;
  }
}
.promises-poster-highlighted-words {
  color: $blue;
}
</style>
